import { IFilter } from "@saleor/components/Filter";
import { AutocompleteFilterOpts, FilterOpts } from "@saleor/types";
import { LockStatus, MfaStatus } from "@saleor/types/globalTypes";
import {
  createAutocompleteField,
  createOptionsField
} from "@saleor/utils/filters/fields";
import { defineMessages, IntlShape } from "react-intl";

export enum StaffFilterKeys {
  status = "status",
  groups = "USER TYPES",
  mfaStatus = "MFA Status"
}

export interface StaffListFilterOpts {
  status: FilterOpts<LockStatus>;
  groups: FilterOpts<string[]> & AutocompleteFilterOpts;
  mfaStatus: FilterOpts<MfaStatus>;
}

const messages = defineMessages({
  active: {
    defaultMessage: "Active",
    description: "staff member's account"
  },
  blocked: {
    defaultMessage: "Blocked",
    description: "staff member's account"
  },
  deactivated: {
    defaultMessage: "Inactive",
    description: "staff member's account"
  },
  expired: {
    defaultMessage: "Expired",
    description: "staff member's account"
  },
  groups: {
    defaultMessage: "User Types",
    description: "staff member's account"
  },
  ineligible: {
    defaultMessage: "Ineligible",
    description: "staff member's account"
  },
  mfaStatus: {
    defaultMessage: "MFA Status",
    description: "staff member's account"
  },
  pending: {
    defaultMessage: "Pending",
    description: "staff member's account"
  },
  status: {
    defaultMessage: "Status",
    description: "staff member's account"
  },
  unverify: {
    defaultMessage: "Unverified",
    description: "staff member's account"
  },
  verified: {
    defaultMessage: "Verified",
    description: "staff member's account"
  }
});

export function createFilterStructure(
  intl: IntlShape,
  opts: StaffListFilterOpts
): IFilter<StaffFilterKeys> {
  return [
    {
      ...createOptionsField(
        StaffFilterKeys.status,
        intl.formatMessage(messages.status),
        [opts.status.value],
        false,
        [
          {
            label: intl.formatMessage(messages.active),
            value: LockStatus.ACTIVE
          },
          {
            label: intl.formatMessage(messages.deactivated),
            value: LockStatus.INACTIVE
          },
          {
            label: intl.formatMessage(messages.blocked),
            value: LockStatus.BLOCKED
          },
          {
            label: intl.formatMessage(messages.unverify),
            value: LockStatus.UNVERIFIED
          }
        ]
      ),
      active: opts.status.active
    },
    {
      ...createAutocompleteField(
        StaffFilterKeys.groups,
        intl.formatMessage(messages.groups),
        opts.groups.value,
        opts.groups.displayValues,
        true,
        opts.groups.choices,
        {
          hasMore: opts.groups.hasMore,
          initialSearch: "",
          loading: opts.groups.loading,
          onFetchMore: opts.groups.onFetchMore,
          onSearchChange: opts.groups.onSearchChange
        }
      ),
      active: opts.groups.active
    },
    {
      ...createOptionsField(
        StaffFilterKeys.mfaStatus,
        intl.formatMessage(messages.mfaStatus),
        [opts.mfaStatus.value],
        false,
        [
          {
            label: intl.formatMessage(messages.verified),
            value: MfaStatus.VERIFIED
          },
          {
            label: intl.formatMessage(messages.pending),
            value: MfaStatus.PENDING
          },
          {
            label: intl.formatMessage(messages.expired),
            value: MfaStatus.EXPIRED
          },
          {
            label: intl.formatMessage(messages.ineligible),
            value: MfaStatus.INELIGIBLE
          }
        ]
      ),
      active: opts.mfaStatus.active
    }
  ];
}
